import { jsxs, jsx } from "react/jsx-runtime";
const IconLanguageSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "m21.897 20.684-4-8.125c-.337-.684-1.457-.684-1.794 0l-4 8.125a1 1 0 0 0 1.794.882L14.67 20h4.662l.772 1.566a1 1 0 0 0 1.794-.882ZM15.653 18 17 15.264 18.347 18h-2.694ZM13 14a1 1 0 1 0 0-2 6.981 6.981 0 0 1-3.397-.893A8.96 8.96 0 0 0 11.952 6H13a1 1 0 1 0 0-2H9.006V3a1 1 0 1 0-2 0v1H3a1 1 0 1 0 0 2h6.93a6.98 6.98 0 0 1-1.92 3.891 6.996 6.996 0 0 1-1.501-2.265 1 1 0 0 0-1.854.752 8.998 8.998 0 0 0 1.76 2.733A6.95 6.95 0 0 1 3.011 12a1 1 0 1 0 0 2 8.946 8.946 0 0 0 4.985-1.513A8.988 8.988 0 0 0 13 14Z" })
    ]
  }
);
export {
  IconLanguageSvg
};
